import React, { useState, useEffect } from "react";
import { message } from "antd";
import { useParams } from "react-router-dom";
import { CustomListService } from "../../Services/CustomListService";
import LayoutLeftMenu from "../../Components/Layout/LayoutLeftMenu";
import LeftMenuSettings from "./LeftSettings";
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import CustomFieldTable from "../../Components/Table/CustomFieldTable";
import { CustomListFieldService } from "../../Services/CustomLifFieldService";
import { WebApiCustomListsDtoCustomListDto, WebApiModelsCustomListField } from "../../Repository/eventbookyapi";

const EditCustomList: React.FC = () => {
    const { id } = useParams<{ id: string }>();
    const [customList, setCustomList] = useState<WebApiCustomListsDtoCustomListDto>({} as WebApiCustomListsDtoCustomListDto);
    const [customListFields, setCustomListFields] = useState<WebApiModelsCustomListField[]>([]);

    const [allCustomLists, setAllCustomLists] = useState<any[]>([]);


    // Helper to load a custom list by id
    const loadCustomList = async (listId: string | number) => {
        try {
            const data = await CustomListService.GetCustomList(Number(listId));
            setCustomList(data);

            CustomListFieldService.GetCCustomListFields(Number(id)).then((fields: WebApiModelsCustomListField[]) => {
                setCustomListFields(fields);
            });
        } catch {
            message.error("Kunde inte hämta listan.");
        }
    };

    // Load custom list and schema
    useEffect(() => {
        if (id) {
            CustomListService.GetCustomLists().then((lists) => {
                const filteredLists = lists.filter(list => list.id !== Number(id));
                setAllCustomLists([...(filteredLists || [])]);
            });
            loadCustomList(id);
        }
    }, [id]);

    return (
        <DndProvider backend={HTML5Backend}>
            <LayoutLeftMenu menu={<LeftMenuSettings selected={"customListsSettings"} />}>
                <h2>Redigera lista: {customList?.name}</h2>
                <CustomFieldTable customList={customList} customListFields={customListFields} allCustomLists={allCustomLists} isMemberList={false} />
            </LayoutLeftMenu>
        </DndProvider>
    );
};

export default EditCustomList;